/* eslint-disable max-len */
import moment from 'moment';
const GeneralData = () =>
    import(/* webpackChunkName: "accounts" */ '@/components/accounts/general-data');
const FiscalData = () =>
    import(/* webpackChunkName: "accounts" */ '@/components/accounts/fiscal-data');
const PositionStates = () =>
    import(/* webpackChunkName: "accounts" */ '@/components/accounts/position-states');

export default {
    /**
     * Nombre del componente
     */
    name: 'AccountsDetailsInfo',

    /**
     * Componentes importados
     */
    components: {
        GeneralData,
        FiscalData,
        PositionStates
    },

    /**
     * @override
     */
    data() {
        return {
            account: null,
            fiscalAddresses: [],
            loadingAddresses: false,
            loadingPositionStates: false,
            accountPositions: []
        };
    },

    props: {
        id: {
            type: String,
            required: false
        },
        creation: {
            type: Boolean,
            required: false
        },
        data: {
            type: Object,
            required: false
        },
        hideActions: {
            type: Boolean,
            required: false
        }
    },

    methods: {
        /**
         * @override
         */
        fetchData() {

        },

        /**
         * OBTENEMOS LISTA DIRECCIONES
         * Obtenemos las direcciones de la cuenta y buscamos cuál es la dirección activa para
         * poner el radiobutton correspondiente seleccionado en la tabla.
         */
        fetchFiscalAddresses() {
            this.loadingAddresses = true;
            this.$accountsService.getAddresses(this.data.uuid)
                .then(res => {
                    const addresses = res.data.accounts_addresses || [];
        
                    if (addresses.length === 0) {
                        this.fiscalAddresses = [];
                        this.loadingAddresses = false;
                        return;
                    }

                    // Obtener todos los intervinientes con rol TITULAR
                    const titularAddresses = addresses.filter(addr => addr.intervener.account_intervener_role === 'TITULAR');
                    const titularUuids = titularAddresses.map(a => a.uuid_intervener);
                    const intervinientesTitulares = this.data.interveners.filter(i => titularUuids.includes(i.uuid));

                    // Identificar si alguno de los titulares es menor
                    const menorTitular = intervinientesTitulares.find(i =>
                        i.personal_data.intervener_type === 'F' &&
                        i.personal_data.birthdate &&
                        moment().diff(i.personal_data.birthdate, 'years') < 18
                    );

                    const isMinor = !!menorTitular;
                    const menorUuid = isMinor ? menorTitular.uuid : null;


                    // Si el titular es menor, usar la dirección del siguiente interviniente en la lista
                    if (isMinor) {
                        // 1. Buscar otro titular adulto distinto del menor
                        const otroTitular = titularAddresses.filter(a => a.uuid_intervener !== menorUuid);
                        if (otroTitular.length) {
                            this.fiscalAddresses = otroTitular;
                        } else {
                            // 2. Si no hay otro titular, buscar tutor o nudo propietario
                            const tutorOrNudo = addresses.filter(a =>['TUTOR', 'NUDO_PROPIETARIO'].includes(a.intervener.account_intervener_role));
                            this.fiscalAddresses = tutorOrNudo ? tutorOrNudo : [];
                        }   
                    } else {
                        // Si no hay menor, mostrar la dirección de todos los titulares
                        this.fiscalAddresses = titularAddresses.length ? titularAddresses : [];
                    } 
                    this.loadingAddresses = false;
                })
                .catch(() => {
                    this.fiscalAddresses = [];
                    this.loadingAddresses = false;
                });
        },

        /**
         * ESTADOS DE POSICIONES
         * Obtenemos las posiciones de la cuenta para cada producto.
         */
        getAccountPositions() {
            this.loadingPositionStates = true;
            this.$accountsService.getAccountPositions(this.data.uuid)
                .then(res => {
                    this.loadingPositionStates = false;
                    this.accountPositions = res.data.account_positions;
                    this.$emit('accountPositionsGot', this.accountPositions);
                })
                .catch(err => console.error(err));
        }
    },

    /**
     * @override
     */
    mounted() {
        this.fetchFiscalAddresses();
        this.getAccountPositions();
    }
};
